import { AudienceSegmentRender } from '../components';
import { createWorkflowUpdatesChangeExtension } from './workflow-updates-change';

export const AUDIENCE_SEGMENT_CHANGE_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'audience-segment-change',
    priority: 1,
    predicate: ({ change }) =>
      change.fieldPath === '/module_data/flags/segment',
    title: () => 'Updated audience targeting',
    render: AudienceSegmentRender,
  });
